import styled from 'styled-components';
import { Box, Stack, Typography } from '@mui/material';
import { formatDuration } from '../../utils/common';
import { radius } from '../../style/utils';

const Bar = styled(Box)<{ width: number }>`
  height: 8px;
  width: ${({ width }) => `${width}%`};
  background: ${({ theme }) => theme.palette.surface.inverseMuted};
  border-radius: ${radius('sm')};
`;

const BarContainer = styled(Box)`
  flex: 2;
  margin: 0;
  padding: 0;
`;

const ExecTimeRenderer = (excTime?: number, maxValue?: number) => {
  const duration = formatDuration(excTime);
  if (!maxValue) {
    return <Typography>{duration}</Typography>;
  }
  const barWidth = ((excTime || 0) / maxValue) * 100;
  return (
    <Stack direction="row" sx={{ gap: 1.5, alignItems: 'center' }}>
      <Typography sx={{ minWidth: '60px' }}>{duration}</Typography>
      <BarContainer>
        <Bar width={barWidth} />
      </BarContainer>
    </Stack>
  );
};

export default ExecTimeRenderer;
